import React, { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import moment from "moment";
import ClientButtonBar from "./ClientButtonBar";
import ProgramMiniCard from "./ProgramMiniCard";
import DocumentsIcon from "./DocumentsIcon";
import getAge from "../services/ageService";
import {
  getFieldDate,
  getFieldName,
  getFieldText,
} from "../../scripts/helperScripts";
import medFragIcon from "../../assets/MedFrag.png";
import { RiParentFill } from "react-icons/ri";

const ClientCard = ({
  client,
  careplans,
  selectedProgram,
  history,
  onFamilyChartClick,
}) => {
  const location = useLocation();
  const clientFlags = useMemo(() => client[0]["con.sor_clientflags"], [client]);
  // const [programs, setPrograms] = useState(client);
  // const isMountedRef = useRef(true);

  // useEffect(() => {
  //   if (client.ccx_client_programid) {
  //     console.log(
  //       "Getting Client Programs for ",
  //       clientProgram["con.contactid"],
  //       user.email
  //     );
  //     getClientPrograms(clientProgram["con.contactid"], user.email).then(
  //       (response) => {
  //         if (isMountedRef.current) {
  //           console.log("Returned Client Programs: ", response);
  //           setPrograms(response);
  //         }
  //       }
  //     );
  //   }
  // }, [user]);

  //Render UI
  return (
    <div className="mb-2">
      <Card className="card-safy" style={{ height: "100%", margin: "0.5rem" }}>
        <Card.Header
          className={
            clientFlags?.includes("chartHolder")
              ? "bg-safy-secondary2 text-black"
              : "bg-safy1-1 text-white"
          }
        >
          <div className="row pe-2">
            <div className="col">
              <div className="h4 mt-0 mb-0 fw-light">
                {client[0]["con.fullname"]}-
                {client[0]["con.ccx_mpistr"] !== undefined ? (
                  client[0]["con.ccx_mpistr"]
                ) : (
                  <>
                    {" "}
                    <span className="bg-danger px-1 text-white h5 rounded">
                      MISSING MPI
                    </span>
                  </>
                )}
              </div>
            </div>
            <div className="col-auto p-0 d-flex justify-content-end">
              {clientFlags?.includes("medFrag") ? (
                <img
                  src={medFragIcon}
                  title="Medically Fragile"
                  alt="Medically Fragile icon"
                  className="me-2"
                  style={{ height: "2.375rem" }}
                ></img>
              ) : null}
              {clientFlags?.includes("chartHolder") ? (
                <RiParentFill
                  title="Family Chart Holder"
                  alt="Family Chart Holder icon"
                  className="me-2 text-safy-secondary"
                  size="2.375rem"
                  onClick={() => {
                    onFamilyChartClick(client[0]);
                  }}
                />
              ) : null}
              <DocumentsIcon
                id={client[0]["con.contactid"].replace(/[{}]/g, "")}
                path="client"
              />
              <Link
                id={client[0]["con.ccx_mpistr"]}
                title="Open Client Program Record"
                to={`/client/${client[0]["con.contactid"].replace(
                  /[{}]/g,
                  ""
                )}`}
                state={{
                  state: client,
                  previousPath: location.pathname,
                  selectedProgram: selectedProgram,
                }}
              >
                <Button className="h-100 bg-safy3-1">
                  <i className="far fa-address-card fa-lg text-light"></i>
                </Button>
              </Link>
            </div>
          </div>
        </Card.Header>
        <Card.Body className="card-body-safy">
          <div className="row">
            <div className="col">
              {getFieldName(client[0]["con.gendercode"])}
              <br />
              DOB: {getFieldDate(client[0]["con.birthdate"])}
              <br />
              <br />
              <div>
                Age: <br />
                {client[0]["con.birthdate"] &&
                  getAge(
                    getFieldDate(client[0]["con.birthdate"]),
                    client[0]["con.ccx_deceaseddate"]
                  )}
              </div>
              {client[0]?.["con.sor_risklevel"] &&
              client[0]?.["con.sor_risklevel"]["@name"] === "High" ? (
                <div className="rounded bg-danger text-white p-2 mt-2 fw-bold">
                  High Risk
                </div>
              ) : null}
              {/* {client[0]?.["con.sor_risklevel"]?.["@name"] === "High" ||
              client[0]["con.sor_clientflags"]?.includes("suicidal") ? (
                <div className="rounded bg-danger text-white p-2 mt-2 fw-bold">
                  High Risk - SI
                  {client[0]["con.sor_clientflags"]?.includes("homicidal")
                    ? " & HI"
                    : ""}
                </div>
              ) : client[0]?.["con.sor_clientflags"]?.includes("homicidal") ? (
                <div className="rounded bg-danger text-white p-2 mt-2 fw-bold">
                  High Risk - HI
                </div>
              ) : null} */}
            </div>
            <div className="col">
              {client &&
                client.map((program) => (
                  <ProgramMiniCard
                    key={program.ccx_client_programid}
                    clientProgram={program}
                    careplan={careplans?.filter(
                      (cp) =>
                        getFieldText(cp.ccx_clientprogram) ===
                        program.ccx_client_programid
                    )}
                    history={history.filter((h) =>
                      program.ccx_client_programid.includes(h.ClientProgramId)
                    )}
                  />
                ))}
            </div>
          </div>
        </Card.Body>
        <Card.Footer
          className={
            clientFlags?.includes("chartHolder")
              ? "bg-safy-secondary2"
              : "bg-safy1-1"
          }
        >
          <ClientButtonBar
            contactId={client[0]["con.contactid"]}
            contactOwner={getFieldName(client[0]["con.ownerid"])}
            programs={client.map((program) => program.ccx_name)}
            size="sm"
          />
        </Card.Footer>
      </Card>
    </div>
  );
};

export default ClientCard;
